/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Checkbox,
  Collapse,
  FormControlLabel,
  IconButton
} from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useState } from 'react'

import { RoleFeature, UpdateFeatureFlagInput } from '../../types/featureFlag'
import useStyles from './styles/featureBox.styles'

type Props = {
  featuresGroup: RoleFeature
  temporaryFeatures: RoleFeature[]
  setTemporaryFeatures: React.Dispatch<React.SetStateAction<RoleFeature[]>>
}

export default function FeatureBox({
  featuresGroup,
  temporaryFeatures,
  setTemporaryFeatures
}: Props) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const allChecked = temporaryFeatures
    .find((rf) => rf.featureGroup === featuresGroup.featureGroup)
    ?.features.every((f) => f.selected)
  const noneChecked = temporaryFeatures
    .find((rf) => rf.featureGroup === featuresGroup.featureGroup)
    ?.features.every((f) => !f.selected)

  const handleSelectAll = (checked: boolean) => {
    setTemporaryFeatures((prev) =>
      prev.map((rf) =>
        rf.featureGroup !== featuresGroup.featureGroup
          ? rf
          : {
              ...rf,
              features: rf.features.map((f) => ({
                ...f,
                selected: checked
              }))
            }
      )
    )
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <IconButton onClick={() => setOpen(!open)}>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
        <FormControlLabel
          label={featuresGroup.featureGroup}
          control={
            <Checkbox
              checked={allChecked}
              onChange={(e) => handleSelectAll(e.target.checked)}
              indeterminate={!allChecked && !noneChecked}
              color="primary"
              size="small"
            />
          }
        />
      </div>
      <Collapse in={open}>
        <div className={classes.body}>
          {featuresGroup.features.map((feature) => (
            <div key={feature.featureID} className={classes.subItem}>
              <FormControlLabel
                label={feature.name}
                control={
                  <Checkbox
                    checked={
                      temporaryFeatures
                        .find(
                          (rf) => rf.featureGroup === featuresGroup.featureGroup
                        )
                        ?.features.find(
                          (f) => f.featureID === feature.featureID
                        )?.selected
                    }
                    onChange={(e) => {
                      const checked = e.target.checked
                      setTemporaryFeatures((prev) =>
                        prev.map((rf) => {
                          if (rf.featureGroup !== featuresGroup.featureGroup) {
                            return rf
                          } else {
                            return {
                              ...rf,
                              features: rf.features.map((f) => {
                                if (f.featureID === feature.featureID) {
                                  return { ...f, selected: checked }
                                } else {
                                  return f
                                }
                              })
                            }
                          }
                        })
                      )
                    }}
                    color="primary"
                    size="small"
                    onClick={(e) => e.stopPropagation()}
                  />
                }
              />
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  )
}
